<template>
  <div>
    <base-title
      :title="StringLanguage.printers"
      :subtitle="StringLanguage.configurations"
      :link="'configuracoes'"
    >
      <base-button text="Reiniciar" @click="restartApp" />
    </base-title>

    <div class="row" v-if="isAppDesktop()">
      <div
        v-if="
          bluetoothConfigurations && !bluetoothConfigurations.enabledBluetooth
        "
      >
        <div
          class="col-lg-6 col-xs-12"
          v-for="(print, index) in printers"
          :key="index"
        >
          <base-box>
            <div class="row">
              <div class="col-lg-6 col-xs-12">
                <base-label :text="print.name" />
              </div>
              <div class="col-lg-6 col-xs-12 action-btns">
                <base-button
                  design="four"
                  @click="
                    $router.push({
                      name: 'impressora',
                      params: { name: print.name },
                    })
                  "
                  title="Configurações avançadas"
                  ><i class="fal fa-cog fs-12"></i
                ></base-button>
                <base-button
                  design="four"
                  class="ml_15"
                  @click="testPrint(print)"
                  title="Imprimir teste"
                  ><i class="fal fa-print fs-12"></i
                ></base-button>
                <base-button
                  design="four"
                  class="ml_15"
                  @click="deletePrinter(index)"
                  title="Remover impressora"
                  ><i class="fal fa-trash-alt fs-12"></i
                ></base-button>
              </div>
            </div>
          </base-box>
        </div>
      </div>

      <div v-else>
        <div
          class="col-lg-6 col-xs-12"
          v-for="(print, index) in bluetoothConfigurations.printers"
          :key="index"
        >
          <base-box>
            <div class="row">
              <div class="col-lg-6 col-xs-12">
                <base-label :text="print.name" />
              </div>

              <div class="col-lg-6 col-xs-12 action-btns">
                <base-button
                  design="four"
                  @click="
                    $router.push({
                      name: 'impressora',
                      params: { name: print.name },
                    })
                  "
                  title="Configurações avançadas"
                  ><i class="fas fa-cog fs-12"></i
                ></base-button>
                <base-button
                  design="four"
                  class="ml_15"
                  @click="testPrint(print)"
                  title="Imprimir teste"
                  ><i class="fal fa-print fs-12"></i
                ></base-button>
                <base-button
                  design="four"
                  class="ml_15"
                  @click="deletePrinter(index)"
                  title="Remover impressora"
                  ><i class="fas fa-trash-alt fs-12"></i
                ></base-button>
              </div>
            </div>
          </base-box>
        </div>
      </div>

      <div class="col-lg-6 col-xs-12">
        <base-add
          :text="StringLanguage.printer.toUpperCase()"
          class="add-printer"
          @click.native="openAddPrinter = !openAddPrinter"
        />
      </div>
    </div>

    <div v-else class="message-printers-web">
      <i class="fal fa-arrow-to-bottom" />
      <p class="title">
        Este recurso não está disponivel na versão web do Easy Delivery.
      </p>
      <p class="description">
        Este recurso não está disponivel nas versões web e mobile do Easy
        Delivery. Para realizar impressões, instale a versão compatível com seu
        sistema operacional em:
      </p>
      <a href="https://easydelivery.com.br/downloads" target="_blank"
        >easydelivery.com.br/downloads</a
      >
    </div>

    <base-drawer
      :open="openAddPrinter"
      :title="
        !enabledBluetooth
          ? StringLanguage.addPrinter
          : 'Selecione a Impressora Bluetooth'
      "
      :close="closeAddPrinter"
    >
      <add-printer
        ref="printerDrawer"
        :devices="bluetoothDevices"
        :printers="systemPrinters"
        @confirmStep="setConfirmStep"
        @testPrint="testPrint"
        @tryPrint="tryPrint"
        @addPrinter="savePrinter"
        @finish="finishAddPrinter"
      />

      <template slot="footer">
        <div v-if="currentAddPrinterStep() == 1">
          <div v-if="!confirmStep()">
            <base-button
              @click="print('test')"
              :text="'Testar'"
              class="w-100 big"
            />
          </div>

          <div v-else>
            <!-- Depois da tentativa -->
            <div class="d-flex">
              <base-button
                :text="'Não imprimiu'"
                design="four"
                class="big w-100"
                @click="setConfirmStep()"
              />
              <base-button
                :text="'Imprimiu'"
                class="ml_15 big w-100"
                @click="next()"
              />
            </div>
          </div>
        </div>

        <div v-else>
          <div v-if="!confirmStep()">
            <!-- Antes da tentativa -->
            <div class="d-flex">
              <base-button
                :text="'Experimentar'"
                @click="print('try')"
                class="big w-100"
              />
            </div>
          </div>

          <div v-else>
            <!-- Depois da tentativa -->
            <div class="d-flex">
              <base-button
                :text="'Não gostei'"
                design="four"
                class="big w-100"
                @click="setConfirmStep()"
              />
              <base-button
                :text="'Gostei'"
                class="ml_15 w-100 big"
                @click="addNewPrinter()"
              />
            </div>
          </div>
        </div>
      </template>
    </base-drawer>
  </div>
</template>

<script>
import Vue from 'vue';
import PrinterList from '@/plugins/core/schema/configurations/Printers/PrinterList';
import StoreAPI from '@/api/store';

import { Print } from '@/plugins/print';
import DesktopBridge from '@/plugins/desktop';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseLabel from '@/components/Label';
import BaseBox from '@/components/Box';
import BaseAdd from '@/components/Add';
import BaseDrawer from '@/components/Drawer';

import AddPrinter from '@/containers/Configurations/Printers/AddPrinter';
import PrintLayout from '@/plugins/printLayout';
import queuePrint from '@/plugins/printQueue';

import AppBridge from '@/plugins/app';
import CatalogAPI from '@/api/catalog';

import Storage2 from '@/plugins/storage2';

export default {
  data() {
    return {
      printers: [],
      categories: [],
      printersBluetooth: [],
      systemPrinters: [],
      addPrinter: false,
      openAddPrinter: false,
      closeAddPrinter: false,
      enabledBluetooth: false,
      bluetoothConfigurations: {},
      bluetoothDevices: [],
      isApp: AppBridge.isApp(),
    };
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseLabel,
    BaseBox,
    BaseAdd,
    BaseDrawer,
    AddPrinter,
  },
  async created() {
    const self = this;

    CatalogAPI.catalogCatalog().then((response) => {
      const { items } = response._data;

      for (const i in items) {
        const categoryName = items[i].name;

        if (categoryName) {
          this.categories.push(categoryName);
        }
      }
    });

    await this.getPrinters();

    if (AppBridge.isApp()) {
      this.bluetoothConfigurations = Storage2.get(
        'local',
        'bluetoothConfigurations'
      );

      if (!this.bluetoothConfigurations) {
        this.bluetoothConfigurations = {};
        this.$set(this.bluetoothConfigurations, 'enabledBluetooth', 0);
      }

      this.getBluetoothDevices();

      AppBridge.listen('BluetoothDevices', (devices) => {
        this.bluetoothDevices = devices;
      });
    }
  },
  methods: {
    restartApp() {
      DesktopBridge.emit('onUpdateNow', 'clientUpdate');
    },
    isAppDesktop() {
      return DesktopBridge.isDesktop();
    },
    onSave() {
      this.savePrinter();
      alert(StringLanguage.saveSuccess);
    },
    set(response) {
      if (response.getErrors([]).length > 0) {
        return false;
      }
      if (response.getData({}).printers) {
        this.printers = [];
        const printersSaved = response.getData({}).printers;

        for (const sprinter of printersSaved) {
          if (sprinter) {
            this.printers.push(sprinter);
          }
        }

        const removeprinter = [];

        for (const i in this.systemPrinters) {
          const filtered = this.printers.filter((a) => {
            if (a.name == this.systemPrinters[i].name) {
              return a;
            }
          });

          if (filtered.length > 0) {
            removeprinter.push(i);
          }
        }

        for (let i = removeprinter.length - 1; i >= 0; i--) {
          this.systemPrinters.splice(removeprinter[i], 1);
        }

        this.$store.dispatch('printers/setPrinters', this.printers);
      } else {
        Vue.set(this, 'printers', new PrinterList().printers);
      }
    },
    beforeDestroy() {
      // this.savePrinter();
    },
    setConfirmStep() {
      if (this.$refs.printerDrawer) {
        this.$refs.printerDrawer.setConfirmStep();
        // this.$refs.printerDrawer.currentStep = !this.$refs.printerDrawer.currentStep;
      }
    },
    currentAddPrinterStep() {
      if (this.$refs.printerDrawer) {
        return this.$refs.printerDrawer.currentStep;
      }
    },
    confirmStep() {
      if (this.$refs.printerDrawer) {
        return this.$refs.printerDrawer.confirmStep;
      }
    },
    next() {
      this.$refs.printerDrawer.next();
    },
    addNewPrinter() {
      this.$refs.printerDrawer.addPrinter();
    },
    async getPrinters() {
      if (DesktopBridge.isDesktop()) {
        DesktopBridge.emit('getPrinters');
        DesktopBridge.listen('getPrinters', (printers) => {
          this.systemPrinters = printers;
        });
      }

      await StoreAPI.storeGetConfiguration('printers').then((response) => {
        this.set(response);
      });
    },
    print(type) {
      if (type == 'test') {
        this.$refs.printerDrawer.testPrint();
      } else {
        this.$refs.printerDrawer.tryPrint();
      }
    },
    async tryPrint(printer) {
      await Print('test', 'try', 'reprintTicket', printer, printer.width);
    },
    async testPrint(printer) {
      if (printer.bluetooth) {
        const data = await Print(
          'test',
          'pedidos',
          'reprintTicket',
          printer,
          printer.width,
          true
        );
        AppBridge.emit('printData', { printer, data });
      } else {
        await Print('test', 'pedidos', 'reprintTicket', printer, printer.width);
      }
    },
    async savePrinter(printer = null) {
      const self = this;

      if (printer && !printer.bluetooth) {
        const categories = {};
        this.categories.map((category) => {
          categories[category] = true;
        });

        printer.layouts.push({
          name: 'Via padrão',
          header: '',
          footer: '',
          blocks: {
            header: true,
            customer: true,
            products: true,
            productsValue: true,
            address: true,
            payment: true,
            footer: true,
          },
          whenAcceptingOrders: true,
          whenEditingOrders: true,
          whenCancelingOrders: true,
          whenOrderingByPhone: true,
          whenOrderingByServiceDesk: true,
          reprintTicket: true,
          categories,
        });

        this.printers.push(printer);
      }

      if (printer != undefined && printer.bluetooth) {
        this.printersBluetooth.push(printer);
        this.bluetoothConfigurations.printers = [printer];

        AppBridge.emit(
          'setBluetoothConfigurations',
          this.bluetoothConfigurations
        );
      } else {
        StoreAPI.storeConfiguration({ printers: this.printers }).then(
          async (response) => {
            this.set(response);
            await this.getPrinters();
          }
        );
      }
    },
    deletePrinter(index) {
      const removedPrinter = this.printers[index];
      console.log(removedPrinter);

      this.printers.splice(index, 1);
      this.savePrinter();
    },
    finishAddPrinter() {
      this.closeAddPrinter = !this.closeAddPrinter;
    },
    enableBluetooth() {
      this.bluetoothConfigurations.enabledBluetooth =
        !this.bluetoothConfigurations.enabledBluetooth;
      AppBridge.emit(
        'setBluetoothConfigurations',
        this.bluetoothConfigurations
      );
    },
    getBluetoothDevices() {
      AppBridge.emit('getBluetoothDevices');
    },
  },
};
</script>
<style scoped>
.message-printers-web {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 75vh;
  justify-content: center;
}

.message-printers-web i {
  font-size: 50px;
  color: var(--default);
  margin-bottom: 40px;
}

.message-printers-web p.title {
  color: #ccc;
  font-size: 22px;
  letter-spacing: 0.2px;
  margin-bottom: 25px;
  text-align: center;
  line-height: 28px;
}

.message-printers-web p.description {
  color: #aaaaabbf;
  font-size: 14px;
  margin-bottom: 20px;
  width: 550px;
  max-width: 100%;
  text-align: center;
  line-height: 22px;
}

.message-printers-web a {
  color: var(--default);
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 3px;
  border-bottom: 1px solid var(--default);
  text-decoration: none;
}

.action-btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
}
.action-btns button {
  padding: 10px;
}
.add-printer {
  height: 100px;
  font-size: 12px;
}

/* RESPONSIVO */
@media (max-width: 991px) {
  .add-printer {
    height: 125px;
  }
  .message-printers-web {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 65vh;
    justify-content: center;
  }

  .message-printers-web i {
    font-size: 40px;
    margin-bottom: 30px;
  }

  .message-printers-web p.title {
    font-size: 18px;
    margin-bottom: 20px;
    width: 350px;
    max-width: 100%;
    line-height: 26px;
  }

  .message-printers-web p.description {
    margin-bottom: 15px;
    width: 550px;
    max-width: 100%;
    line-height: 20px;
  }
}

@media print {
  #printable {
    display: block !important;
  }
}
</style>
